module.exports = __webpack_public_path__ + "static/media/woodford.c4757ecf.png";